<div class="float-right">
  <div>
    <ng-container *ngIf="!protected">
      {{ amount | currency: '' + currency }}
    </ng-container>
    <ng-container *ngIf="protected">
      *****
    </ng-container>
  </div>
  <div>
    <ng-container *ngIf="cancelled">
      <nz-tag nzColor="error">CANCELLED</nz-tag>
    </ng-container>

    <ng-container *ngIf="bounced">
      <nz-tag nzColor="orange">BOUNCED</nz-tag>
    </ng-container>

    <ng-container *ngIf="pdc">
      <nz-tag nzColor="blue">PDC</nz-tag>
    </ng-container>

    <div *ngIf="!cancelled && !bounced" class="float-right">
      <nz-tag *ngIf="showOutstanding && outstanding === 0" nzColor="success">PAID</nz-tag>
      <div *ngIf="outstanding > 0" class="text-red">
        <span>O/T:</span>
        <span *ngIf="!protected">{{ outstanding | currency: currency + '' }}</span>
        <span *ngIf="protected">*****</span>
      </div>
    </div>
  </div>
</div>
